import cx from 'classnames';
import React from 'react';
import Base, { Config } from 'components/scourge/Base';
import { history } from 'modules/navigator';
import styles from './index.module.scss';


interface Props {
  onClick?: (id:number) => void
  data: any
  type?: 'mine'
}

// export default class ClassItem extends Base<any, Props> {
export default class ClassItem extends React.Component<any, Props> {
  

  public render() {
    const { data, type } = this.props;

    return data?(
        
        <div className={styles.item} onClick={this.handleClick.bind(null, data.id)}>
          <div className={styles.left}>
            <img className={styles.img} src={data.image}></img>
            {data.status == 2 && <div className={styles.reserve}>课程预告</div>}
          </div>
          <div className={styles.right}>
            <div className={styles.line}>
              <p className={cx(styles.h2, styles.flx)}>{data.name}</p>
              <p className={styles.rig}>{data.class_num}课时</p>
            </div>
            <div className={styles.line}>
              <p className={styles.p}>{data.desc? data.desc.replace(/\n|\r/g,""): ''}</p>
            </div>
            <div className={cx(styles.line, styles.marg)}>
              <p className={styles.tag}>{data.lecturer.name}</p>
              <p className={styles.tag}>{data.lecturer.job}</p>
              <p className={styles.tag1}>认证讲师</p>
            </div>
            {type == 'mine' ? (
              <div className={styles.line}>
                <p className={styles.rate}>已完成{data.rate}%</p>
              </div>
            ): (
              <div className={styles.line}>
                
                  <div className={styles.flx}>
                    <p className={styles.small} style={{display: 'none'}}>¥{data.origin_price}</p>
                    <p className={styles.price} style={{display: 'none'}}>会员价:{data.vip_price}</p>
                  </div>
                
                {data.status != 2 && <p className={styles.rig}>{data.sale_num}人加入学习</p>}
              </div>
            )}
          </div>
        </div>
          
    ): (<div></div>);
  }


  private handleClick = (id) => {
    // this.navigator.push('videoDetail', {id})
    history.push('/payment/videoDetail',{id})
    const { onClick } = this.props
    if(onClick) {
      onClick(id)
    }
  }

  
}
